export function LogoMark({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
      <rect width="64" height="64" rx="10" fill="#0E0E0E" stroke="#262626" />
      <path d="M19 15h26L33 33v11h8v4H23v-4h8V33L19 15z" stroke="#D98B48" strokeWidth="2.5" strokeLinejoin="round" fill="none" />
      <circle cx="47" cy="47" r="3.5" fill="#C5A059" />
    </svg>
  );
}

export function Logo({ className = "", markClassName = "h-9 w-9" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="brand-logo">
      <LogoMark className={markClassName} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-2xl tracking-[0.22em] uppercase text-[#F5F5F5]">
          Estielle
        </span>
        <span className="mt-1.5 text-[9px] font-medium uppercase tracking-[0.42em] text-[#C5A059]">
          Mobile Bartending
        </span>
      </span>
    </span>
  );
}
